<template>
  <div class="page-authenticate">
    <div class="container">
      <div class="page-header">
        <h2>{{ title }}</h2>
      </div>
      <div class="page-body">
        <!-- TODO: ARTIFICIAL_AUTH 类型还需完善交互方式 -->
        <div v-if="authType !== 'ARTIFICIAL_AUTH'">
          <a-steps
            class="mod-step"
            v-model="step"
            labelPlacement="vertical"
          >
            <a-step title="认证方式" disabled>
              <span class="circle" slot="icon" />
            </a-step>
            <a-step title="实名认证" disabled>
              <a-icon slot="icon" type="user" />
            </a-step>
            <a-step v-if="type === 'auth'" title="实名认证完成" disabled>
              <a-icon slot="icon" type="check" />
            </a-step>
            <a-step v-else-if="type === 'forgetPassword'" title="找回密码" disabled>
              <a-icon slot="icon" type="check" />
            </a-step>
            <template v-else>
              <a-step title="修改信息" disabled>
                <a-icon slot="icon" type="edit" />
              </a-step>
              <a-step title="修改完成" disabled>
                <a-icon slot="icon" type="check" />
              </a-step>
            </template>
          </a-steps>
          <step1 v-if="step === 0" :userInfo="userInfo" :ffpUserInfo="ffpUserInfo" :name="userInfo.fullName" :title="title" :type="type" :authTypeMenus="authTypeMenus" @next="onNext"></step1>
          <step2 v-if="step === 1" :userInfo="userInfo" :ffpUserInfo="ffpUserInfo" :type="type" :authType="authType" @next="onNext"></step2>
          <change-password v-if="step === 2 && type === 'password'" :event="1" :realNameToken="codeToken" @next="onNext"></change-password>
          <change-info v-if="step === 2 && (type === 'mobile' || type === 'email')" action="change" :type="type" :event="1" :codeToken="codeToken" @next="onNext"></change-info>
          <ffp-binding v-if="step === 2 && type === 'ffpBinding'" :event="1" :realNameToken="codeToken" @next="onNext"></ffp-binding>
          <forget-password v-if="step=== 2 && type === 'forgetPassword'" :token="token" :checkedToken="codeToken"></forget-password>
          <success v-if="step === 3 || (step === 2 && type === 'auth')" :title="title"></success>
        </div>
        <other v-else :userInfo="userInfo" @back="onBack"></other>
      </div>
    </div>
  </div>
</template>

<script>
import queryString from 'query-string'
import { get } from 'lodash'
import Step1 from './components/Step1'
import Step2 from './components/Step2'
import ChangePassword from '../password/components/Change'
import ChangeInfo from '../binding/components/Form'
import FfpBinding from '../ffp-binding/components/Form'
import ForgetPassword from '../forget-password/components/step3'
import Success from './components/Success'
import Other from './components/Other'
import { fetchInfo } from '@/api/member'
import './index'

const typeMap = {
  password: '修改密码',
  mobile: '修改手机',
  email: '修改邮箱',
  ffpBinding: '绑定金鹏卡',
  forgetPassword: '找回密码',
  auth: '实名认证'
}

export default {
  data () {
    return {
      type: 'password',
      token: '',
      title: '',
      step: 0,
      codeToken: '',
      userInfo: {},
      ffpUserInfo: null,
      authType: 'UNION_PAY_AUTH',
      qrCode: '',
      faceQrCode: '',
      airline: window.__MICRO_ROOT__?.airline,
      authTypeMenus: []
    }
  },
  created () {
    this.getCmsData()

    const params = queryString.parse(location.search)

    if (params.source === 'mobile' && params.userToken) {
      // 兼容移动端
      this.$ls.set('USER_CENTER_TOKEN', params.userToken, 2 * 60 * 60 * 1000)
      this.fetch()
    } else {
      const userInfo = this.$ls.get('USER_CENTER_INFO')

      if (userInfo) {
        this.userInfo = userInfo
      }

      if (params.type !== 'forgetPassword') {
        this.fetch()
      }
    }

    this.type = params.type
    this.token = params.token
    this.title = typeMap[params.type]

    if (!this.title) {
      this.$message.error('未知操作，即将返回上一页')
      setTimeout(() => {
        history.go(-1)
      }, 2000)
    }
  },
  computed: {
    authTypeCodeList () {
      return this.authTypeMenus.map(item => { return item.code })
    }
  },
  methods: {
    async getCmsData () {
      const pageCmsData = (await window.__MICRO_ROOT__?.cms?.getPageData()) ?? {}
      this.authTypeMenus = get(pageCmsData, 'authenticate-config.menus') ?? []
    },
    async fetch () {
      try {
        const data = await fetchInfo({})

        this.userInfo = data.user
        this.ffpUserInfo = data.ffpUserInfo || null
        this.$ls.set('USER_CENTER_INFO', data.user)
      } catch (err) {
        this.loading = false
        this.$message.error(err.message)
      }
    },
    onNext (data) {
      const { step } = this

      if (step === 0 && typeof data === 'string') {
        this.authType = data
        if (data === 'ARTIFICIAL_AUTH') return
      }

      if (step === 1) {
        this.codeToken = data
      }

      this.step = step + 1
    },
    onBack () {
      this.authType = 'UNION_PAY_AUTH'
    }
  },
  components: {
    Step1,
    Step2,
    ChangePassword,
    ChangeInfo,
    FfpBinding,
    ForgetPassword,
    Success,
    Other
  }
}
</script>
